import { memo } from 'react'
import { useConfig } from 'builder/hooks/useConfig'
import { Props } from '../types'
import { CardContainer } from './styles'
import { CreateNewResume } from './CreateNewResume'
import { CreateWithAI } from './CreateWithAI'
import { UseExample } from './UseExample'
import { UploadResume } from './UploadResume'
import { CreateWithLinkedinProfile } from './CreateWithLinkedinProfile'

const OptionCards = ({ onClose }: Props) => {
  const config = useConfig()
  const {
    aiResumeDraft = false,
    startWithExamples = false,
    uploadResume = false,
    startWithLinkedin = false,
  } = config?.features ?? {}

  const enabledFeatureCount = [
    aiResumeDraft,
    startWithExamples,
    uploadResume,
    startWithLinkedin,
  ].filter(Boolean).length

  return (
    <CardContainer gridCount={enabledFeatureCount}>
      <CreateNewResume {...{ onClose }} />
      {aiResumeDraft && <CreateWithAI {...{ onClose }} />}
      {uploadResume && <UploadResume />}
      {startWithLinkedin && <CreateWithLinkedinProfile {...{ onClose }} />}
      {startWithExamples && <UseExample {...{ onClose }} />}
    </CardContainer>
  )
}

export default memo(OptionCards)
